

// faq
import './faq/faqSection.sass';
import './faq/qasection.sass';
import './faq/quickLink.sass';

//home
import './home/IntroSection.sass';
import './home/GamePlaySection.sass';
import './home/RecruitHeroes.sass';
import './home/DiscoverKingdom.sass';
import './home/MasterElements.sass';
import './home/Carousel.sass';
import './home/CarouselItem.sass';
import './home/Mage.sass';
import './home/Enemies.sass';
import './home/Puff.sass';
import './home/HundredsHeroes.sass';
//common
import './common/VideoOverlay.sass';

// mobile
import './mobile/SignUpPage.sass';
import './mobile/CodeRedeem.sass';
import './mobile/ConfirmPage.sass';
import './mobile/CodeConfirmPage.sass';
import './mobile/DeviceSelect.sass';
import './mobile/Header.sass';
import './mobile/GetStarted.sass';
import './mobile/AndroidDownload.sass';
import './mobile/AndroidDownloadNewFlow.sass';
import './mobile/SimpleCodeRedeem.sass';
